import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { useRequiredParams } from 'hooks/params.hook'
import { palletProductsAtom } from '../Assemby.state'

export const usePalletDetail = () => {
  const navigate = useNavigate()
  const { container } = useRequiredParams('container')
  const products = useAtomValue(palletProductsAtom)

  const onGoBack = () => {
    navigate(-1)
  }

  return { container, products, actions: { onGoBack } }
}
